import { render, staticRenderFns } from "./VehicleHolder.vue?vue&type=template&id=398d70b7&scoped=true&"
import script from "./VehicleHolder.vue?vue&type=script&lang=js&"
export * from "./VehicleHolder.vue?vue&type=script&lang=js&"
import style0 from "./VehicleHolder.vue?vue&type=style&index=0&id=398d70b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d70b7",
  null
  
)

export default component.exports